import type { ReactNode } from 'react';

/** Campo somente leitura com destaque (C-10) — ex.: dados recuperados da base Impacto. */
export default function LockedField({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="locked">
      <div className="label">{label}</div>
      <div className="v">{value || '—'}</div>
    </div>
  );
}
